import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import accountHelpers from '../../../../utils/accountHelpers';
import classes from '../chat.module.scss';

const transitionStyle = 'left 200ms, right 200ms';

const UserTabs = ({ changeTab, userRolesTemplate, currentTab }) => {
  const tabRef = useRef(null);
  const [sizes, changeSizes] = useState(null);

  const changeTabs = (e, tabName, requestRoles) => {
    changeTab(tabName, requestRoles);

    const rootBounds = tabRef.current.getBoundingClientRect();
    const bounds = e.target.getBoundingClientRect();

    const left = bounds.left - rootBounds.left;
    const right = rootBounds.right - bounds.right;

    changeSizes({ left, right });
  };

  const getUnderlineStyle = () => {
    if (!sizes) {
      return { left: '15px', right: '187px' };
    }
    return {
      left: `${sizes.left}px`,
      right: `${sizes.right}px`,
      transition: transitionStyle,
    };
  };

  return (
    <div ref={tabRef} className={classes.user_tab_wrapper}>
      { userRolesTemplate.map(({
        tabName, requestRoles, color, showForRoles,
      }) => (
        showForRoles.includes(accountHelpers.getUser().role) && (
        <div
          key={tabName}
          style={{ color, pointerEvents: tabName === currentTab.tabName ? 'none' : 'auto' }}
          onClick={(e) => changeTabs(e, tabName, requestRoles)}
        >
          {tabName}
        </div>
        )
      ))}

      <div className={classes.tabs_underline} style={{ ...getUnderlineStyle(), background: currentTab.color }} />
    </div>
  );
};

UserTabs.propTypes = {
  changeTab: PropTypes.func.isRequired,
  currentTab: PropTypes.object.isRequired,
  userRolesTemplate: PropTypes.array.isRequired,
};

export default UserTabs;
